import { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

interface StyledDivProps {
  children?: ReactNode;
}

export const WrapTop = styled.div<StyledDivProps>`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: space-between;
`;

interface CloseButtonProps {
  children?: ReactNode;
  onClick?: any;
  type?: string;
}

export const CloseButton = styled.button<CloseButtonProps>`
  font-size: 20px;
  color: #555;
  border: none;
  background-color: transparent;

  &:hover {
    cursor: pointer;
  }
`;

export const TitleModal = styled.h2<StyledDivProps>`
  color: ${({ theme }) => theme.palette.neutral.dark};
  font:
    600 18px 'Open Sans',
    sans-serif;
  letter-spacing: -0.0278em;
  margin: 6px 0 3px;
`;

export const SubtitleModal = styled.span<StyledDivProps>`
  font-weight: 400;
  color: ${({ theme }) => theme.palette.neutral.dark};
`;

export const logoStyle: CSSProperties = { padding: 0, maxWidth: '60px' };
